import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { AuthState, initialAuthState } from './auth.state';

const reducer = createReducer(
  initialAuthState,
  on(AuthActions.login, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.loginSuccess, (state, { user, token, refreshToken }) => ({
    ...state,
    user,
    token,
    refreshToken,
    loading: false,
    error: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AuthActions.logout, () => initialAuthState),
  on(AuthActions.hydrate, (state, { user, token }) => ({
    ...state,
    user,
    token,
  })),
  on(AuthActions.refreshSuccess, (state, { token, refreshToken }) => ({
    ...state,
    token,
    refreshToken,
  })),
  on(AuthActions.updateProfile, (state) => ({
    ...state, profileSaving: true, profileSaveSuccess: false, profileError: null,
  })),
  on(AuthActions.updateProfileSuccess, (state, { user }) => ({
    ...state, user, profileSaving: false, profileSaveSuccess: true,
  })),
  on(AuthActions.updateProfileFailure, (state, { error }) => ({
    ...state, profileSaving: false, profileError: error,
  })),
  on(AuthActions.clearProfileSaveSuccess, (state) => ({ ...state, profileSaveSuccess: false })),
  on(AuthActions.changePassword, (state) => ({
    ...state, passwordSaving: true, passwordSaveSuccess: false, passwordError: null,
  })),
  on(AuthActions.changePasswordSuccess, (state) => ({
    ...state, passwordSaving: false, passwordSaveSuccess: true,
  })),
  on(AuthActions.changePasswordFailure, (state, { error }) => ({
    ...state, passwordSaving: false, passwordError: error,
  })),
  on(AuthActions.clearPasswordSaveSuccess, (state) => ({ ...state, passwordSaveSuccess: false }))
);

export const authFeature = createFeature<'auth', AuthState>({
  name: 'auth',
  reducer,
});
